import React from 'react';

import { useTranslation } from '@lt/localization';
import styled from 'styled-components';
import RoomDescription from './RoomDescription';
import Gallery from '../Gallery';
import type { RoomProps } from './types';

const baseCls = 'lt-room-info';

const Room = ({
  name_ru: name,
  description,
  hotel_room_facility_types: facilities,
  images,
  isMobile,
}: RoomProps & { isMobile: boolean }) => {
  const { t } = useTranslation();
  return (
    <StyledRoom className={baseCls} isMobile={isMobile}>
      {Array.isArray(images) && images.length > 0 && (
        <Gallery
          className={`${baseCls}__gallery`}
          data={images.map(({ x900 }) => x900)}
          alt={name}
        />
      )}
      <div className={`${baseCls}__description`}>
        {description ? (
          <RoomDescription
            className={`${baseCls}__description__item`}
            title={name}
          >
            {description}
          </RoomDescription>
        ) : null}
        {facilities && facilities.length !== 0 && Array.isArray(facilities) && (
          <RoomDescription
            className={`${baseCls}__description__item`}
            title={t('checkout.packageInfo.room.description')}
          >
            <ul className={`${baseCls}-facilities`}>
              {facilities.map((item) => {
                const facilityName = item.name || item.original_name;
                return (
                  <li
                    key={facilityName}
                    className={`${baseCls}-facilities__item`}
                  >
                    {facilityName}
                  </li>
                );
              })}
            </ul>
          </RoomDescription>
        )}
      </div>
    </StyledRoom>
  );
};

const StyledRoom = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) =>
    isMobile &&
    `
  max-width: 90vw;
  max-height: calc(100vh - 100px);
  overflow: scroll;

  .${baseCls}__gallery {
    max-width: 100%;
    min-height: 120px;
    .carousel .slide img {
      object-fit: cover;
      height: 280px;
    }
  }

  .lt-carousel {
    .thumbs {
      display: none;
    }
    .control-prev {
      margin-top: 4px;
    }
    .control-arrow::before{
      width: 20px !important;
      height: 54px !important;
    }
  }

  .${baseCls}__description {
    padding: 20px;
    display: block;

    &__item {
      margin-bottom: 20px;
      padding: 0;
      box-sizing: border-box;
      width: 100%;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .${baseCls}-facilities {
    &__item {
      width: 100%;
    }
  }

  .${baseCls}-description {
    &__title {
      margin: 0;
      margin-bottom: 5px;
      padding: 0;
      border-bottom: none;
    }
  }
  `}
`;

export default Room;
